export const REGISTER_SIMPLY = '/api/account/registerSimply';
export const PHONE_NUMBER = '/api/account/phoneNumber';
export const SMS_CODE = '/api/account/smsCode';
export const CALL_CODE = '/api/account/callCode';
export const REGISTER_INTER_RISK_PATIENT = '/api/account/registerInterRiskPatient';